module.exports = __webpack_public_path__ + "img/BF_Logo_Full_CROPPED.cff448df.svg";